import logger from './logger';
import { LoggerTags } from './constants/loggerTags';

/**
 * Log a native share error
 *
 * @param {Error} error - The error to log.
 * @param {string} [url] - Optional identifier for the url where the error occurred; used for logging.
 * Specify a [set][of][braces] leading to the file/page where the error has occurred.
 */
const logNativeShareError = (error: Error, url?: string) => {
  logger.message(LoggerTags.NATIVE_SHARE_ERROR, error.name, {
    ...(url ? { url } : {}),
    message: error.message,
    traceback: error.stack,
  });
};

export default logNativeShareError;
